import { render, staticRenderFns } from "./UserPath.vue?vue&type=template&id=25c3e726&scoped=true&"
import script from "./UserPath.vue?vue&type=script&lang=js&"
export * from "./UserPath.vue?vue&type=script&lang=js&"
import style0 from "./UserPath.vue?vue&type=style&index=0&id=25c3e726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3e726",
  null
  
)

export default component.exports